import {CircleIcon, DotFillIcon, PauseIcon} from '@primer/octicons-react'

import type {TriageState} from './utils/constants'

type IndicatorIconProps = {
  state: TriageState
  ariaLabel: string
  isError: boolean
}

export function TriageAgentStatusIcon({state, ariaLabel, isError}: IndicatorIconProps) {
  if (isError) {
    return <DotFillIcon size={12} aria-label={ariaLabel} />
  }

  switch (state) {
    case 'inactive':
      return <CircleIcon size={12} aria-label={ariaLabel} />
    case 'active':
      return <DotFillIcon size={16} aria-label={ariaLabel} />
    case 'paused':
      return <PauseIcon size={12} aria-label={ariaLabel} />
  }
}

try{ TriageAgentStatusIcon.displayName ||= 'TriageAgentStatusIcon' } catch {}